import { render, staticRenderFns } from "./CompletionNoteTextArea.vue?vue&type=template&id=6125dbb4&"
import script from "./CompletionNoteTextArea.vue?vue&type=script&lang=js&"
export * from "./CompletionNoteTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports